import React from "react";

class DefaultAvatar extends React.Component {
  chooseColor(firstLetter, secondLetter) {
    // Need to use something to generate colors since some users don't have full names
    let firstInitial = firstLetter != "" ? firstLetter : "a";
    let secondInitial = secondLetter != "" ? secondLetter : "a";
    const colors = [
      { text: "#2f6051", bg: "#47bb98" },
      { text: "#55403b", bg: "#d97358" },
      { text: "#c7f7f7", bg: "#2e93c6" },
      { text: "#bcdff2", bg: "#604bc6" },
      { text: "#f2cfbc", bg: "#ac3d4d" },
      { text: "#bbb5ad", bg: "#474857" },
      { text: "#7fa7b5", bg: "#1a4a77" },
      { text: "#6f5d2b", bg: "#dbb13b" },
      { text: "#4ecac3", bg: "#2e6661" },
      { text: "#608ac1", bg: "#481f6c" },
    ];
    // Get first letters distance from 'a'
    let firstModifier = firstInitial.charCodeAt(0) - 97;
    // Invert the second modifier to get a more 'random' result
    let secondModifier = (secondInitial.charCodeAt(0) - 97) * -1 + 25;
    let finalModifier = (firstModifier + secondModifier) / 2;
    let optionsRatio = colors.length / 26; // 0.38461538461538464
    let chosenIndex = Math.round(finalModifier * optionsRatio) - 1;
    if (chosenIndex < 0) chosenIndex = 2;
    return colors[chosenIndex];
  }

  render() {
    let width = this.props.dim.split("x")[0];
    let height = this.props.dim.split("x")[1];
    let firstName = Number.isInteger(this.props.name) ? String(this.props.name)[0] : this.props.name.split(" ")[0];
    let lastName = Number.isInteger(this.props.name) ? String(this.props.name % 10) : this.props.name.split(" ")[1];
    let firstInitial = firstName ? firstName.charAt(0).toLowerCase() : "";
    let secondInitial = lastName ? lastName.charAt(0).toLowerCase() : "";
    let color = this.chooseColor(firstInitial, secondInitial);

    if (this.props.alertCounter) {
      if (Number.isInteger(this.props.name) && this.props.name >= 10) {
        firstInitial = "9";
        secondInitial = "+";
      } else {
        secondInitial = "";
      }
    }
    return (
      <svg
        className={`${this.props.className} ${this.props.department}`}
        style={{
          borderRadius: this.props.alertCounter && "8px",
          pointerEvents: "none",
          backgroundColor: !this.props.alertCounter && this.props.bg ? this.props.bg : this.props.alertCounter && this.props.bg ? this.props.bg : "#30336A",
          minWidth: `${width}px`,
          minHeight: `${height}px`,
        }}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={`${width}px`}
        height={`${height}px`}>
        <rect
          x="0"
          y="0"
          width={`${width}px`}
          height={`${height}px`}
          style={{ fill: this.props.alertCounter ? (this.props.bg ? this.props.bg : "#30336A") : this.props.bg && !this.props.alertCounter ? this.props.bg : color.bg }}
        />
        <text
          x="50%"
          y="50%"
          dy=".1em"
          fill={this.props.alertCounter ? "white" : this.props.bg ? "white" : color.text}
          textAnchor="middle"
          dominantBaseline="middle"
          style={{ fontFamily: "var(--primary-font)", fontSize: width / 2, lineHeight: 1 }}>
          {firstInitial.toUpperCase() + secondInitial.toUpperCase()}
        </text>
      </svg>
    );
  }
}

export default DefaultAvatar;
